import { useState } from 'react';
import { Link } from 'react-router-dom';

import { EditFilled, PlusOutlined, SearchOutlined } from '@ant-design/icons';

import { Button, Input, Table, Tag, Tooltip } from 'antd';

import { RoleMenuHeader as columns } from '@/utils/tableHeader';
import '@/assets/style/modern-group-list.css';

// api
import { roleApiEndpoints } from '@/api/endpoints';
import { useFetch } from '@/hooks';

import { globalSearch } from '@/utils/search/Search';
import React from 'react';

/**
 * roles list component
 * @returns
 */

const RoleMenuMappingList = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { data, isLoading, isSuccess } = useFetch(
    roleApiEndpoints.menuMappingList,
  );

  return (
    <>
      <div className="modern-group-page">
        <div className="modern-group-header-row">
          <div className="modern-group-header">
            <h1 className="modern-group-title">Menu Role Mapping</h1>
            <p className="modern-group-subtitle">
              Manage and organize menu role mappings
            </p>
          </div>
          <div className="modern-group-actions">
            <Input
              className="header-search"
              name="query"
              placeholder="Search Role..."
              value={searchQuery}
              prefix={<SearchOutlined />}
              onChange={(event) => setSearchQuery(event.target.value)}
              style={{ width: '300px' }}
            />
            <Link to="/role/menu/mapping/create/">
              <Button type="primary" className="centered">
                <PlusOutlined />
                Create
              </Button>
            </Link>
          </div>
        </div>

        <div className="table-responsive modern-table-wrapper">
          <Table
            size="large"
            bordered
            loading={isLoading}
            columns={columns?.map((col) => ({
              ...col,
              onCell: () => ({
                style: {
                  padding: '6px 12px',
                },
              }),
            }))}
            scroll={{ x: true, y: 'calc(100vh - 220px)' }}
            className="ant-border-space"
            style={{ textAlign: 'center' }}
            pagination={{
              hideOnSinglePage: true,
            }}
            dataSource={
              isSuccess
                ? globalSearch(data, searchQuery)?.map((role, index) => {
                    return {
                      key: role.referenceId,
                      index: index + 1,
                      company: (
                        <span className="font-bold cursor-pointer">
                          {role.company}
                        </span>
                      ),
                      branch: (
                        <span className="font-bold cursor-pointer">
                          {role.branchName}
                        </span>
                      ),
                      role: (
                        <span className="font-bold cursor-pointer">
                          {role.role}
                        </span>
                      ),
                      menus: (
                        <span className="font-bold cursor-pointer w-ellipsis">
                          {role.menus?.slice(0, 3).map((item, index) => (
                            <Tag
                              key={index}
                              color={index % 2 === 0 ? 'green' : 'blue'}
                            >
                              {item}
                            </Tag>
                          ))}
                          {role.menus?.length > 3 && (
                            <span className="text-gray-500">
                              ... {role.menus.length - 3} more
                            </span>
                          )}
                        </span>
                      ),
                      action: (
                        <div className="ant-action tw-flex tw-gap-4 tw-justify-center tw-align-center">
                          <Tooltip title="Edit">
                            <Link
                              to={`/menu/mapping/${role.roleId}/${role.branchId}/${role.companyId}/edit/`}
                              className="edit tw-inline-flex tw-cursor-pointer hover:tw-bg-blue-200 tw-rounded-full tw-p-1"
                            >
                              <EditFilled className="tw-text-blue-600" />
                            </Link>
                          </Tooltip>
                        </div>
                      ),
                    };
                  })
                : []
            }
          />
        </div>
      </div>
    </>
  );
};

export default RoleMenuMappingList;
